import { EquipmentFilterMemoryState } from 'features/ui';
import { FilterReconcileMemory } from './equipment-comparison-filters';

export function filterReconcileMemoryFromState(
  state: EquipmentFilterMemoryState
): FilterReconcileMemory {
  return {
    configIds: new Set(state.configIds),
    airHandlerTypes: new Set(state.airHandlerTypes),
    condenserSeries: new Set(state.condenserSeries),
    condenserBtus: new Set(state.condenserBtus),
    hyperHeat: new Set(state.hyperHeat),
    systemTypes: new Set(state.systemTypes),
    refrigerants: new Set(state.refrigerants)
  };
}

export function filterReconcileMemoryToState(
  memory: FilterReconcileMemory
): EquipmentFilterMemoryState {
  return {
    configIds: Array.from(memory.configIds).sort((a, b) => a.localeCompare(b)),
    airHandlerTypes: Array.from(memory.airHandlerTypes).sort((a, b) =>
      a.localeCompare(b)
    ),
    condenserSeries: Array.from(memory.condenserSeries).sort((a, b) =>
      a.localeCompare(b)
    ),
    condenserBtus: Array.from(memory.condenserBtus).sort((a, b) => a - b),
    hyperHeat: Array.from(memory.hyperHeat).sort(),
    systemTypes: Array.from(memory.systemTypes).sort(),
    refrigerants: Array.from(memory.refrigerants).sort((a, b) =>
      a.localeCompare(b)
    )
  };
}

function isSameArray<T>(a: ReadonlyArray<T>, b: ReadonlyArray<T>): boolean {
  if (a.length !== b.length) {
    return false;
  }
  return a.every((value, index) => value === b[index]);
}

export function isSameEquipmentFilterMemory(
  a: EquipmentFilterMemoryState,
  b: EquipmentFilterMemoryState
): boolean {
  return (
    isSameArray(a.configIds, b.configIds) &&
    isSameArray(a.airHandlerTypes, b.airHandlerTypes) &&
    isSameArray(a.condenserSeries, b.condenserSeries) &&
    isSameArray(a.condenserBtus, b.condenserBtus) &&
    isSameArray(a.hyperHeat, b.hyperHeat) &&
    isSameArray(a.systemTypes, b.systemTypes) &&
    isSameArray(a.refrigerants, b.refrigerants)
  );
}
